export default [
  {
    path: '/experiences',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'experiences-list' */ '@/views/experiences/List.vue')
  }, {
    path: '/experiences/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'experiences' */ '@/views/experiences/Experience.vue')
  }
]
